import { http } from '.';
import { ApiEnvelope, MembershipResponse, MembershipSetDetailResponse } from 'types/api';

export const getMembershipDetails = async (params: {
  shopSeqNo: number;
}): Promise<MembershipResponse[]> => {
  const response = await http.get<ApiEnvelope<MembershipResponse[]>>(`/memberships/details`, {
    params,
  });
  return response.data;
};

export const getOneMembershipDetail = async (membershipDetailId: string) => {
  const response = await http.get<ApiEnvelope<MembershipResponse[]>>(
    `/memberships/details/${membershipDetailId}`,
  );

  return response.data;
};

export const postMembershipSets = async (payload: any) => {
  const response = await http.post<ApiEnvelope<MembershipResponse[]>>(`/memberships/sets`, payload);
  return response.data;
};

export const postMemberships = async (payload: any) => {
  const response = await http.post<ApiEnvelope<MembershipResponse>>(`/memberships`, payload);
  return response.data;
};

export const getMembershipSet = async (membershipSetId: string) => {
  const response = await http.get<ApiEnvelope<MembershipSetDetailResponse>>(
    `/memberships/sets/${membershipSetId}`,
  );
  return response.data;
};
